import type { EndpointDef } from "@/features/users/data/endpoints";

import { getEndpointById } from "./getEndpointById";

/**
 * Revisa un payload de `permissions` y devuelve advertencias para
 * cualquier scope cuyo endpoint tenga `auth: "none"`. La búsqueda es
 * exacta por `id` (path HTTP con `/` inicial).
 *
 * No bloquea el envío: el caller decide qué hacer con las advertencias
 * (típicamente `console.warn` por scope y un toast en otra capa).
 */
export function validateApiKeyPayload(
  permissions: string[],
  endpoints: EndpointDef[]
): { warnings: string[] } {
  const warnings: string[] = [];

  for (const scope of permissions) {
    const ep = getEndpointById(scope, endpoints);
    if (ep && ep.auth === "none") {
      warnings.push(scope);
    }
  }

  return { warnings };
}
